<template>
  <div class="no-cameras" v-if="!hasCameras"></div>
  <b-container fluid v-else class="live-view-wall-container">
    <b-row>
      <b-col cols="4" v-for="(printer, index) in geIdlePrintersWithActiveCamera" :key="index">
        <div class="live-view-wall-printer-name">
          <strong>{{calculatePrinterName(printer)}}</strong>
          <printer-status :printer="printer"></printer-status>
        </div>
        <camera-live-view :printer-id="printer.printer_id" :webcam-id="printer.webcam_id" width="640" height="480" :center="false"></camera-live-view>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import {mapGetters} from 'vuex';

  import PrinterMixin from "@/mixins/printer";
  import PrinterStatus from "./printer/PrinterStatus";
  import CameraLiveView from "./camera/CameraLiveView";

  export default {
    name: 'live-view-wall',
    mixins: [PrinterMixin],
    components: {
      CameraLiveView,
      PrinterStatus
    },
    computed: {
      ...mapGetters(['geIdlePrintersWithActiveCamera']),

      hasCameras() {
        return this.geIdlePrintersWithActiveCamera.length > 0;
      }
    }
  }
</script>

<style scoped lang="scss">
  .no-cameras {
    width: 100%;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .live-view-wall-container {
    .row {
      .col-4 {
        margin-top: 20px;
      }
    }
  }
  .live-view-wall-printer-name {
    width: 100%;
    margin-bottom: 5px;

    strong {
      margin-right: 10px;
    }
  }
</style>